import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  NEXT_BUTTON: `${cleanedFilename(__filename)}-next-button`,
};
